import { render, staticRenderFns } from "./user-profile-actions.vue?vue&type=template&id=d8484f82"
import script from "./user-profile-actions.vue?vue&type=script&lang=js"
export * from "./user-profile-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports